import { Navigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

const RedirectToEmployeeListPage = () => {
  const { navigation } = useNavigation()
  const to = navigation.employees.list.fullPath()

  return <Navigate replace to={to} />
}

export default RedirectToEmployeeListPage
